var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconStatistics(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.71429 5.71429C9.71429 4.76786 10.4821 4 11.4286 4H12.5714C13.5179 4 14.2857 4.76786 14.2857 5.71429V18.2857C14.2857 19.2321 13.5179 20 12.5714 20H11.4286C10.4821 20 9.71429 19.2321 9.71429 18.2857V5.71429ZM4 12.5714C4 11.625 4.76786 10.8571 5.71429 10.8571H6.85714C7.80357 10.8571 8.57143 11.625 8.57143 12.5714V18.2857C8.57143 19.2321 7.80357 20 6.85714 20H5.71429C4.76786 20 4 19.2321 4 18.2857V12.5714ZM17.1429 6.28571H18.2857C19.2321 6.28571 20 7.05357 20 8V18.2857C20 19.2321 19.2321 20 18.2857 20H17.1429C16.1964 20 15.4286 19.2321 15.4286 18.2857V8C15.4286 7.05357 16.1964 6.28571 17.1429 6.28571Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconStatistics);
export default __webpack_public_path__ + "static/media/icon-statistics.dcdc9f06dbdc0a1e9cfd9f7ef20ce374.svg";
export { ForwardRef as ReactComponent };